import { render, staticRenderFns } from "./SampleReview.vue?vue&type=template&id=a1380740&"
import script from "./SampleReview.vue?vue&type=script&lang=ts&"
export * from "./SampleReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports